import type { ScrapeJob } from '../types';

import { API_URL } from './api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

export const saveScrapeJob = async (job: ScrapeJob): Promise<ScrapeJob> => {
  const response = await fetch(`${API_URL}/api/scrapes`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(job),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to save scrape job');
  }

  const result = await response.json();
  return result.data;
};

export const fetchScrapeJobs = async (): Promise<ScrapeJob[]> => {
  // Add a timestamp to bypass any potential browser/edge caching
  const timestamp = Date.now();
  const response = await fetch(`${API_URL}/api/scrapes?t=${timestamp}`, {
    headers: {
      ...getAuthHeaders(),
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch scrape jobs');
  }

  const result = await response.json();
  return result.data;
};

export const fetchScrapeJob = async (id: string): Promise<ScrapeJob> => {
  const response = await fetch(`${API_URL}/api/scrapes/${id}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch scrape job');
  }

  const result = await response.json();
  return result.data;
};

export const deleteScrapeJob = async (id: string): Promise<void> => {
  const response = await fetch(`${API_URL}/api/scrapes/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to delete scrape job');
  }
};

export const updateScrapeJob = async (id: string, updates: Partial<ScrapeJob>): Promise<ScrapeJob> => {
  const response = await fetch(`${API_URL}/api/scrapes/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error('Failed to update scrape job');
  }

  const result = await response.json();
  return result.data;
};